import React, { useEffect, useRef, useState } from 'react'
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import '../../DataTableDemo.css';
import { set } from 'lodash';
import { InputNumber } from 'primereact/inputnumber';
import { Carousel } from 'primereact/carousel';
import './CarouselDemo.css'
import apis from '../../api';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Pending.css'
import Maps from '../Maps/Maps';
import useWindowDimensions from '../hooks/useDimensions';
import Maps2 from '../Maps/Maps2';
import { MultiSelect } from 'primereact/multiselect';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Galleria } from 'primereact/galleria';
import { Tooltip } from 'primereact/tooltip';

const Pending = () => {

    const [fechaInicioConsulta, setFechaInicioConsulta] = useState("")
    const [fechaFinConsulta, setFechaFinConsulta] = useState("")
    const [contrato, setContrato] = useState("")

    const [idSolicitud, setIdSolicitud] = useState("")
    const [tipo, setTipo] = useState("")
    const [consolidado, setConsolidado] = useState("")
    const [diasTiempo, setDiasTiempo] = useState("")
    const [diasDinero, setDiasDinero] = useState("")
    const [fechaInicio, setFechaInicio] = useState("")
    const [fechaFin, setFechaFin] = useState("")

    const [fechaInicioAusentismo, setFechaInicioAusentismo] = useState("")
    const [fechaFinAusentismo, setFechaFinAusentismo] = useState("")
    const [contingencia, setContingencia] = useState("")
    const [tiempo, setTiempo] = useState("")
    const [observaciones, setObservaciones] = useState("")
    const [adjunto, setAdjunto] = useState("")

    const [longitud, setLongitud] = useState(0)
    const [latitud, setLatitud] = useState(0)
    const [trackFotos, setTrackFotos] = useState([])
    const [trackInfo, setTrackInfo] = useState({})
    const [trackDescription, setTrackDescription] = useState("")

    const [listaTipo, setListaTipo] = useState([])
    const [listaContratos, setListaContratos] = useState([])
    const [listaContingencia, setListaContingencia] = useState([])

    const [registros, setRegistros] = useState([]);
    const [rowState, setRowState] = useState([]);

    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loadPage, setLoadPage] = useState(false)

    const [isOpenA, setIsOpenA] = useState(false)
    const [isOpenR, setIsOpenR] = useState(false)
    const [isOpenD, setIsOpenD] = useState(false)

    const [type, setType] = useState([])

    const [isOpenMapa, setIsOpenMapa] = useState(false)

    const toast = useRef(null);
    const elementWidth = { width: "12rem" }
    const labelStyle = {
        display: "block",
        float: "left",
        marginTop: "5px",
        width: "100%",
        paddingTop: "5px"
    }

    const { width } = useWindowDimensions()

    const headers = {
        authorization: localStorage.getItem('token')
    }

    /*Propiedades de la tabla del componente*/
    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState("");
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [noveltyCauseList, setNoveltyCauseList] = useState([])
    const [noveltyCauseInfo, setNoveltyCauseInfo] = useState("")
    const [causal, setCausal] = useState("")

    const [isOpenCausal, setIsOpenCausal] = useState(false)

    const [clientList, setClientList] = useState([])
    const [entityList, setEntityList] = useState([])
    const [client, setClient] = useState("")
    const [entity, setEntity] = useState("")


    const containerStyles = {
        display: 'block',
        maxWidth: '200px',
        // maxHeight: '200px',
        width: 'auto',
        height: 'auto'
    };

    const imgStyles = {
        width: '100%',
        height: '100%',
    };

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        setTabla()
    }, [])

    useEffect(() => {
        const template = async () => {
            await apis.getPendRequests(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let tipos = res.data.TYPE_NOVELTIES
                let contratos = res.data["CONTRACTS"]
                setListaTipo(tipos)
                setListaContratos(contratos)
            })
        }
        template()
    }, [])

    const showModalA = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenA(true);
    };

    const hideModalA = () => {
        setIsOpenA(false);
        setCausal("")
        // limpiar();
    };

    const showModalR = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenR(true);
    };

    const hideModalR = () => {
        setIsOpenR(false);
        // limpiar();
    };

    const showModalD = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenD(true);
    };

    const hideModalD = () => {
        setIsOpenD(false);
        setAdjunto("")
    };

    const showModalMapa = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenMapa(true);
    };

    const hideModalMapa = () => {
        setIsOpenMapa()
    };

    const showModalCausal = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenCausal(true);
    };

    const hideModalCausal = () => {
        setIsOpenCausal(false);
        //limpiar();
    };

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
                    <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button loading={loading1} label="Consultar" icon="pi pi-search" className=" mr-2 p-button-sm" onClick={() => { setLoading1(true); setTabla() }} />
                <Button disabled={registros.length < 1} label="Aprobar" icon="pi pi-check" className=" mr-2 p-button-sm p-button-success" onClick={() => { showModalA() }} />
                <Button disabled={registros.length < 1} label="Rechazar" icon="pi pi-times" className=" mr-2 p-button-sm p-button-danger" onClick={() => { showModalR() }} />
            </React.Fragment>
        )
    }

    const selectItemTemplate = (option) => {
        return (
            <div className="flex jsutify-content-start align-items-center">
                <img alt={""} src={option.IMAGES} width={50} height={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
                &nbsp;
                &nbsp;
                &nbsp;
                <span>{option.CODE} - {option.NAME}</span>
            </div>
        );
    };

    const leftToolbarTemplate = () => {
        return (
            <div className='flex flex-row'>
                <Dropdown value={contrato} autofocus optionLabel='NAME' style={{ width: '12rem' }} itemTemplate={selectItemTemplate}
                    filter showClear filterBy="NAME,CODE" emptyMessage={"No hay contratos disponibles"}
                    onChange={(e) => setContrato(e.value)} options={listaContratos} placeholder="Contrato" />
                &nbsp;
                <Calendar id="navigators" value={fechaInicioConsulta} onChange={(e) => setFechaInicioConsulta(e.value)} locale="es"
                    dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                    placeholder="Fecha inicio" style={{ width: '12rem' }}
                />
                &nbsp;
                <Calendar id="navigators" value={fechaFinConsulta} onChange={(e) => setFechaFinConsulta(e.value)} locale="es"
                    dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                    placeholder="Fecha fin" style={{ width: '12rem' }}
                />
            </div>
        )
    }

    const renderHeader1 = () => {
        const msg = "Para filtrar la información, seleccione uno o varios tipos de novedades.\n Si lo desea, seleccione una empresa. Esto habilitará los clientes\n pertenecientes a dicha empresa y se podrá realizar el filtro por los 3 campos"
        return (
            <div className="barra1">
                <div className='flex align-items-center'>
                    <Tooltip target=".info" className='indigo-tooltip ml-1'/>
                    <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} disabled={type.length === 0} />
                    &nbsp;
                    <i className="info pi pi-info-circle cursor-pointer" data-pr-tooltip={msg} data-pr-position='bottom'
                        data-pr-classname="text-primary" style={{ color: '#00a8ff', fontSize: '1.2rem' }} />
                    &nbsp;
                    <MultiSelect value={type} options={listaTipo} onChange={(e) => filterByType(e.value)} optionLabel="description"
                        placeholder="Tipo novedades" style={{ width: '12rem' }} maxSelectedLabels={1} selectedItemsLabel='{0} tipos seleccionados' />
                    &nbsp;
                    <Dropdown value={entity} options={entityList} onChange={(e) => filterByEntity(e.value)} optionLabel="NAME" showClear
                        placeholder="Empresa" style={{ width: '12rem' }} tooltip={entity?.NAME} tooltipOptions={{position: 'top'}}/>
                    &nbsp;
                    <Dropdown value={client} options={clientList} onChange={(e) => filterByClient(e.value)} optionLabel="NAME" showClear disabled={!entity}
                        placeholder="Cliente" style={{ width: '12rem' }} tooltip={client?.NAME} tooltipOptions={{position: 'top'}}/>
                </div>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText className="p-inputtext-sm w-full" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </IconField>
            </div>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div style={{ width: "10rem" }}>
                <Button icon="pi pi-align-justify" className="p-button-warning mr-2 p-button-sm text-xs" tooltip="Detalle" 
                loading={rowState[rowData.rowId]}
                onClick={async () => { 
                    setRowState({ ...rowState, [rowData.rowId]: true });
                    initializeData(rowData);
                    await getRequestDetail(rowData.REQUESTS_ID).then(res => {
                        setRowState({ ...rowState, [rowData.rowId]: false });
                    })
                }} 
                />
                <Button icon="pi pi-check" className="p-button-success mr-1 p-button-sm text-xs" tooltip="Aprobar" tooltipOptions={{ position: 'top' }}
                    onClick={() => {
                        setRegistros([rowData]);
                        if (rowData.TURN_HE_ADI && rowData.TURN_HE_ADI === 'S') {
                            showModalCausal()
                        }
                        else {
                            showModalA()
                        }
                    }} />
                <Button icon="pi pi-times" className="p-button-danger p-button-sm text-xs" tooltip="Rechazar" tooltipOptions={{ position: 'top' }} onClick={() => { setRegistros([rowData]); showModalR() }} />
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        console.log(filters1)
        initFilters1();
        setType([])
        setRows(selectedRows)
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'REQUESTS_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NOVELTY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'UNITY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    async function initializeData(row) {
        setIdSolicitud(row.REQUESTS_ID)
        setTipo(row.NOVELTY_ID)
    }

    const applyFilters = (types, entity_, client_) => {
        let filtered = selectedRows.map(row => ({
            ...row,
        }));
    
        if (entity_) {
            filtered = filtered.filter(row => row.ENTITY === entity_.CODE);
        }
    
        if (client_) {
            filtered = filtered.filter(row => row.CLIENT === client_.CODE);
        }
    
        if (types && types.length > 0) {
            console.log(types, filtered)
            filtered = filtered.filter(row =>
                types.some(type => row.NOVELTY_ID === type.detail_id)
            );
        }
    
        setRows(filtered);
    };

    const filterByType = (types) => {
        setType(types);
        applyFilters(types, entity, client);
    };

    const filterByEntity = (entity_) => {
        setEntity(entity_);
        setClient("")
        setClientList(entity_?.CLIENTS ? entity_.CLIENTS : [])
        applyFilters(type, entity_, entity_  ? client : undefined);
    };

    const filterByClient = (client_) => {
        setClient(client_);
        applyFilters(type, entity, client_ ? client_ : undefined);
    };

    const getCauseList = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        try {
            await apis.noveltyCauseList(_entity, _client, headers).then(res => {
                setNoveltyCauseInfo(res.data.OBSERVATION)
                setNoveltyCauseList(res.data.TRK_APD_CAUSAL)
            })
        }
        catch (error) {
            console.log(error)
        }
    }

    const getRequestDetail = async (id) => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        console.log(tipo)
        try {
            await apis.getRequest(_entity, _client, id, headers).then(res => {
                let solicitud = res.data
                let tipo = solicitud.NOVELTY.split("|")
                if (tipo[0] === "VAC") {
                    setConsolidado(solicitud.DAY_CSO)
                    setDiasDinero(solicitud.DAYS_DIN)
                    setDiasTiempo(solicitud.DAYS_TIE)
                    setFechaInicio(invDateFormat(solicitud.START_DATE))
                    setFechaFin(invDateFormat(solicitud.END_DATE))
                    if (solicitud.FILES && solicitud.FILES.length > 0) {
                        let adjuntos = solicitud.FILES[0]
                        setAdjunto(adjuntos)
                    }
                }
                else if (tipo[0] === "ABS") {
                    let _contingencia = solicitud.CONTINGENCY.split("|")
                    setFechaInicioAusentismo(invDateFormat(solicitud.START_DATE))
                    setFechaFinAusentismo(invDateFormat(solicitud.END_DATE))
                    setContingencia({ CODE: _contingencia[0], TYPE: _contingencia[0], NAME: _contingencia[1] })
                    setTiempo(solicitud.DAYS)
                    setObservaciones(solicitud.OBSERVATIONS)
                    if (solicitud.FILES && solicitud.FILES.length > 0) {
                        let adjuntos = solicitud.FILES[0]
                        setAdjunto(adjuntos)
                    }
                }
                else if (tipo[0] === "TRK") {
                    console.log(solicitud)
                    let location = solicitud.GEOLOCATION
                    let imagenes = {
                        ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
                        DETAIL: solicitud.FILES ? solicitud.FILES : []
                    }
                    let info = {
                        DATE: solicitud.DATE ? solicitud.DATE : "",
                        TIME: solicitud.TIME ? solicitud.TIME : "",
                        TYPE: solicitud.TYPE ? solicitud.TYPE : "",
                        STATUS: solicitud.STATUS ? solicitud.STATUS : "",
                        NUMBER_ID: solicitud.NUMBER_ID
                    }
                    setLongitud(parseFloat(location.LON))
                    setLatitud(parseFloat(location.LAT))
                    setTrackDescription(solicitud.CONTRACT_ID)
                    setTrackFotos(imagenes)
                    setTrackInfo({
                        ...trackInfo,
                        ...info
                    })
                }
                else if (tipo[0] === "TURN") {
                    let location = solicitud.GEOLOCATION
                    location[0]["LAT"] = parseFloat(location[0]["LAT"])
                    location[0]["LON"] = parseFloat(location[0]["LON"])
                    location[1]["LAT"] = parseFloat(location[1]["LAT"])
                    location[1]["LON"] = parseFloat(location[1]["LON"])
                    let imagenes = {
                        ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
                        DETAIL: solicitud.FILES ? solicitud.FILES : []
                    }
                    let info = {
                        DATE_IN: solicitud.DATE_IN ? solicitud.DATE_IN : "",
                        DATE_OUT: solicitud.DATE_OUT ? solicitud.DATE_OUT : "",
                        TIME_IN: solicitud.TIME_IN ? solicitud.TIME_IN : "",
                        TIME_OUT: solicitud.TIME_OUT ? solicitud.TIME_OUT : "",
                        STATUS: solicitud.STATUS ? solicitud.STATUS : "",
                        NUMBER_ID: solicitud.NUMBER_ID,
                        TURN_HE_ADI: solicitud.TURN_HE_ADI
                    }
                    setLongitud([location[0]['LON'], location[1]['LON']])
                    setLatitud([location[0]['LAT'], location[1]['LAT']])
                    setTrackDescription(solicitud.CONTRACT_ID)
                    setTrackFotos([imagenes, imagenes])
                    setTrackInfo({
                        ...trackInfo,
                        ...info
                    })
                }
            })
            showModalD()
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const setTabla = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = contrato ? contrato.CODE : "NULL"
        const _estado = 'PDTE'
        const _fechaInicio = fechaInicioConsulta ? dateFormat(fechaInicioConsulta) : "NULL"
        const _fechaFin = fechaFinConsulta ? dateFormat(fechaFinConsulta) : "NULL"

        try {
            await apis.getAllRequests(_entity, _client, _estado, _contract, _fechaInicio, _fechaFin, headers).then(res => {
                if (res.data.NOVELTIES.length > 0) {
                    let data = res.data.NOVELTIES
                    let solicitudes = []
                    let entity_list = []
                    let client_list = []
                    let states = {}
                    let rowCounter = 0;
                    data.forEach(element => {
                        let registro = element
                        let solicitud = registro.NOVELTY.split("|")
                        let contrato = registro.CONTRACT_ID.split("|")
                        let estado = registro.STATUS.split("|")
                        let idSolicitud = solicitud[0]
                        let idContrato = contrato[0]
                        let idEstado = estado[0]
                        solicitud = solicitud[1]
                        contrato = contrato[1]
                        estado = estado[1]
                        registro.NOVELTY = solicitud
                        registro.CONTRACT_ID = idContrato
                        registro.STATUS = estado
                        registro = {
                            ...registro,
                            NOVELTY_ID: idSolicitud,
                            CONTRACT: contrato,
                            STATUS_ID: idEstado,
                            rowId: rowCounter,
                        }
                        states = {
                            ...states,
                            [rowCounter]: false
                        }
                        let entityIndex = entity_list.findIndex(ent => ent.CODE === element.ENTITY)
                        if(entityIndex !== -1){
                            let ent = entity_list[entityIndex]
                            let clients = [...ent.CLIENTS]
                            if(!ent.CLIENTS.some(cli => cli.CODE === element.CLIENT)){
                                let newClient = {
                                    CODE: element.CLIENT,
                                    NAME: element.CLIENT_NAME
                                }
                                clients.push(newClient)
                            }
                            ent = {
                                ...ent,
                                CLIENTS: [...clients]
                            }
                            entity_list[entityIndex] = ent
                        }
                        else{
                            let newClient = {
                                CODE: element.CLIENT,
                                NAME: element.CLIENT_NAME
                            }
                            let newEntity = {
                                CODE: element.ENTITY,
                                NAME: element.ENTITY_NAME,
                                CLIENTS: [newClient]
                            }
                            entity_list.push(newEntity)
                        }
                        solicitudes.push(registro)
                        rowCounter++
                    });
                    setRowState(states)
                    setRows(solicitudes)
                    setClientList(client_list)
                    setEntityList(entity_list)
                    getCauseList()
                    setSelectedRows(solicitudes)
                    setType([])
                    setLoadPage(true)
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Consulta exitosa" })
                }
                else {
                    setRows([])
                    setSelectedRows([])
                    setType([])
                    setLoadPage(true)
                    toast.current.show({ severity: 'warn', summary: 'Éxito', detail: "Consulta sin resultados" })
                }
                setLoading1(false)
                setLoadPage(true)
            })
        }
        catch (err) {
            setRows([])
            setLoadPage(true)
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const changeStatus = async (status) => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        let noveltyCause = []
        let novelties = ''
        let msg = status === 'REC' ? 'Rechazada(s)' : 'Aprobada(s)'
        registros.forEach(reg => {
            novelties = novelties + (reg.REQUESTS_ID + ",")
            if (reg.TURN_HE_ADI && reg.TURN_HE_ADI === 'S') {
                noveltyCause.push(reg)
            }
        })
        novelties = novelties.slice(0, -1)

        const requests = {
            ENTITY: _entity,
            CLIENT: _client,
            STATUS: status,
            NOVELTIES: novelties,
            TURN_CAUSAL: causal && causal.detail_id
        }

        if (noveltyCause.length === 0 || registros.length === 1) {
            try {
                await apis.putRequests(requests, headers).then(res => {
                    setLoading2(false)
                    setLoading3(false)
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Solicitud(es) " + msg + " exitosamente" });
                    setTabla()
                    setRegistros([])
                    hideModalA()
                    hideModalR()
                })
            }
            catch (err) {
                setLoading2(false)
                setLoading3(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
        }
        else {
            let newMsg = ""
            noveltyCause.forEach((nov, index) => {
                if (index + 1 < noveltyCause.length) {
                    newMsg += nov.REQUESTS_ID + ", "
                }
                else {
                    newMsg += nov.REQUESTS_ID
                }
            })
            newMsg = "Para el(los) registro(s) " + newMsg + ": " + noveltyCauseInfo
            setLoading2(false)
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: newMsg, sticky: true });
        }
    }

    const footerAprobar = (
        <div>
            <Button label="Si" loading={loading2} onClick={() => { setLoading2(true); changeStatus('APD') }} />
            <Button label="No" onClick={() => hideModalA()} />
        </div>
    );

    const headerAprobar = (
        <div>
            <h3>{registros.length > 1 ? '¿Desea aprobar las solicitudes seleccionadas?' : '¿Desea aprobar esta solicitud?'}</h3>
        </div>
    )

    const footerRechazar = (
        <div>
            <Button label="Si" loading={loading3} onClick={() => { setLoading3(true); changeStatus('REC') }} />
            <Button label="No" onClick={() => hideModalR()} />
        </div>
    );

    const headerRechazar = (
        <div>
            <h3>{registros.length > 1 ? '¿Desea rechazar las solicitudes seleccionadas?' : '¿Desea rechazar esta solicitud?'}</h3>
        </div>
    )

    const detailHeader = (
        <div>
            <h3>Detalle solicitud</h3>
        </div>
    );

    const itemTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ width: '100%', display: 'block', maxHeight: '40vh' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ display: 'block', maxHeight: "100px", maxWidth: "150px" }} />;
    }

    const header = <div className='flex justify-content-center mt-2'>
        <h4>Entrada y salida de la novedad</h4>
    </div>

    const addFooterCausal = (
        <div>
            <Button onClick={hideModalCausal} label='Cancelar' />
            <Button label='Aceptar' disabled={!causal} onClick={() => { showModalA(); hideModalCausal() }} />
        </div>
    );

    const addHeaderCausal = (
        <div>
            <h3>{noveltyCauseInfo}</h3>
        </div>
    );

    const buttonStyle = {
        overflow: "hidden",
        maxWidth: "20rem"
    }

    const bodyTemplate = (rowData) => {
        let text = rowData.TURN_HE_ADI ? rowData.TURN_HE_ADI === 'S' ? 'Si' : 'No' : 'No aplica'
        return (
            <div>
                <span>{text}</span>
            </div>
        );
    }

    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8'>
            <Toast ref={toast} />
            <Dialog header={headerAprobar} footer={footerAprobar} visible={isOpenA} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalA}>
            </Dialog>
            <Dialog header={headerRechazar} footer={footerRechazar} visible={isOpenR} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalR}>
            </Dialog>
            <Dialog header={detailHeader} visible={isOpenD} position="top" style={tipo !== "TRK" ? { width: "26rem" } : { width: "70vw", height: "90vh" }}
                draggable={false} resizable={false} modal onHide={hideModalD}>
                {tipo === "VAC" ? <><label style={labelStyle} htmlFor="label">Dias consolidado</label>
                    <InputNumber min={0} value={consolidado} placeholder="Dias consolidado" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Dias tiempo</label>
                    <InputNumber min={0} value={diasTiempo} placeholder="Dias tiempo" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Dias Dinero</label>
                    <InputNumber min={0} value={diasDinero} placeholder="Dias Dinero" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                    <Calendar id="navigators" value={fechaInicio} locale="es"
                        dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                    />
                    <label style={labelStyle} htmlFor="label">Fecha fin</label>
                    <Calendar id="navigators" value={fechaFin} locale="es" dateFormat="dd-mm-yy"
                        yearRange="2010:2030" disabled={true} showIcon />
                    {adjunto &&
                        <>
                            <label style={labelStyle} htmlFor="label">Adjunto</label>
                            <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                                onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                        </>
                    }</>
                    : tipo === "ABS" ?
                        <div className='flex flex-column'>
                            <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                            <Calendar id="navigators" value={fechaInicioAusentismo} disabled={true} locale="es"
                                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                            />
                            <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                            <Calendar id="navigators" value={fechaFinAusentismo} locale="es"
                                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                            />
                            <label style={labelStyle} htmlFor="label">Contingencia</label>
                            <Dropdown value={contingencia} autofocus optionLabel='NAME'
                                filter showClear filterBy="NAME" emptyMessage={"No hay tipos disponibles"}
                                disabled={true} options={listaContingencia} placeholder={contingencia ? contingencia.NAME : 'Seleccione'} />
                            <label style={labelStyle} htmlFor="label">Tiempo</label>
                            <InputNumber min={0} value={tiempo} placeholder="Tiempo" disabled={true} />
                            <label style={labelStyle} htmlFor="label">Observaciones</label>
                            <InputTextarea maxLength={70} value={observaciones} disabled={true} rows={4} cols={30} />
                            {adjunto &&
                                <>
                                    <label style={labelStyle} htmlFor="label">Adjunto</label>
                                    <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                                        onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                                </>
                            }
                        </div>
                        : tipo === 'TRK' ?
                            <>
                                <Maps2 latitud={[latitud]} longitud={[longitud]} descripcion={[trackDescription]} icon={[trackFotos]} info={[trackInfo]} />
                                {/* <div className="carousel-demo2">
                                <Carousel value={trackFotos} numVisible={1} numScroll={1} itemTemplate={itemTemplate} header={header} className="custom-carousel" />
                            </div> */}
                            </>
                            :
                            <>
                                <label className='font-bold' style={labelStyle} htmlFor="label">Ingreso:</label>
                                <span className='font-bold'>Fecha: </span>
                                <span>{trackInfo.DATE_IN} </span>
                                <span className='font-bold'>Hora: </span>
                                <span>{trackInfo.TIME_IN} </span><br />
                                <label className='font-bold' style={labelStyle} htmlFor="label">Salida:</label>
                                <span className='font-bold'>Fecha: </span>
                                <span>{trackInfo.DATE_OUT} </span>
                                <span className='font-bold'>Hora: </span>
                                <span>{trackInfo.TIME_OUT}</span><br />
                                {trackInfo.TURN_HE_ADI && <><span className='font-bold'>Causal: {trackInfo.TURN_HE_ADI === 'S' ? "Si" : "No"}</span><br /><br /></>}
                                <Button label='Ver ubicación' icon='pi pi-eye' size='small' onClick={showModalMapa} /><br /><br />
                                {trackFotos[0] && trackFotos[0].DETAIL && trackFotos[0].DETAIL.length > 0 &&
                                    <div className='card'>
                                        <Galleria value={trackFotos[0].DETAIL} responsiveOptions={responsiveOptions} numVisible={5} style={{ maxWidth: '640px' }}
                                            item={itemTemplate} thumbnail={thumbnailTemplate} />
                                    </div>}
                            </>
                }
            </Dialog>
            <Dialog visible={isOpenMapa} draggable={false} resizable={false} modal onHide={hideModalMapa} style={{ width: "70vw", height: "90vh" }}>
                <Maps2 latitud={latitud} longitud={longitud} descripcion={[]} icon={trackFotos} info={[trackInfo]} />
            </Dialog>
            <Dialog header={addHeaderCausal} footer={addFooterCausal} visible={isOpenCausal}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCausal}>
                <Dropdown value={causal} autofocus optionLabel='description' onChange={(e) => setCausal(e.value)} style={{ width: "20rem" }}
                    filter showClear filterBy="description" emptyMessage={"No hay causales disponibles"} tooltip={causal && causal.descripcion}
                    options={noveltyCauseList} placeholder={causal ? causal.description : 'Seleccione'} />
            </Dialog>
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">Solicitudes pendientes</span>
            </div>
            <div className="mt-6">
                <SkeletonTable load={loadPage}>
                    <Toolbar className='pending card flex flex-row' start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>
                    <DataTable className="card text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                        selectionMode="multiple" selection={registros} onSelectionChange={(e) => setRegistros(e.value)} dataKey="REQUESTS_ID"
                        size="small" filters={filters1} filterDisplay="menu"
                        globalFilterFields={['REQUESTS_ID', 'NOVELTY', 'CONTRACT_ID', 'CONTRACT', 'START_DATE', 'UNITY', 'END_DATE', 'STATUS']}
                        header={header1} >
                        <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
                        <Column field="REQUESTS_ID" header="Id solicitud" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                        <Column field="NOVELTY" header="Tipo solicitud" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
                        <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
                        <Column field="CONTRACT" header="Nombre" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por nombre" sortable></Column>
                        <Column field="ENTITY_NAME" header="Empresa" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por empresa" sortable></Column>
                        <Column field="CLIENT_NAME" header="Cliente" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por cliente" sortable></Column>
                        <Column field="START_DATE" header="Feha inicio" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
                        <Column field="UNITY" header="Dias" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por días" sortable></Column>
                        <Column field="END_DATE" header="Feha fin" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin" sortable></Column>
                        <Column field="TYPE" header="Marcación" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin" sortable></Column>
                        <Column field="TIME" bodyStyle={{textAlign: 'start', overflow: 'visible', width: "10rem"}} headerStyle={{ width: '10rem', textAlign: 'center' }} header="Hora" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin" sortable></Column>
                        <Column field="TURN_HE_ADI" header="Causal" body={bodyTemplate} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
                        <Column field="STATUS" header="Estado" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
                        <Column header="Acciones" headerStyle={{ width: '10rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', width: "10rem" }} body={actionBodyTemplate} />
                    </DataTable>
                </SkeletonTable>
            </div>
        </div>
    )
}

export default Pending
